module.exports = __webpack_public_path__ + "static/img/tkxt.979be7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tkxt.png
// module id = lx4x
// module chunks = 0